import { useTranslation } from 'react-i18next'

import { FormikField } from '../../../../Formik'
import { SwitchInput } from '../../../../Switch'
import { TASK_FORM_VISIBILITY_FIELD_NAME } from '../../TaskForm.constants'

function VisibilityField() {
  const { t } = useTranslation()

  return (
    <FormikField
      Component={SwitchInput}
      fieldComponentProps={{
        info: t('Task.FormVisibilityFieldInfoTooltipKey'),
        label: `${t('Task.FormVisibilityFieldLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      label={t('Task.FormVisibilityFieldSwitchLabelKey')}
      name={TASK_FORM_VISIBILITY_FIELD_NAME}
    />
  )
}

export default VisibilityField
